import DataModel from "../../ts/model-factory/basic/data/DataModel";
import React, {useEffect, useState} from "react";
import {getManager} from "../../ts/manager/Manager";
import LoadingPartial from "../partial/status/LoadingPartial";
import {IRouteProps} from "../../ts/manager/view/ViewInterface";
import {dispatchRedirectHome} from "../../ts/event/DispatchEvent";
import eventBus from "../../ts/event/EventBus";
import {IFactoryData} from "../../ts/model-factory/basic/ModelFactoryInterface";
import ErrorConditionalPartial from "../partial/status/ErrorConditionalPartial";


interface ViewState
{
    isInitialized: boolean;
    hasCurrentData: boolean;
    overrideView: React.JSX.Element|null
}

interface IProps
{
    routeProps: IRouteProps;
    assert?:(IFactoryData|null)[]|(IFactoryData|null);
    dataModels?: DataModel|(DataModel|null)[]|null;
    redirectOnLogin?: boolean
    redirectOnLogout?: boolean
    checkForUserLocation?: boolean;
    promptForUserLocation?: boolean;
}


const StateViewController = (props:IProps): ViewState =>
{
    const isPathActive = () => {
        return getManager().navigation.model.realPath.startsWith(props.routeProps.choice.realPath);
    }

    const promptForUserLocation = !!props.promptForUserLocation;
    const checkForUserLocation = !!props.checkForUserLocation || promptForUserLocation;

    const dataModels: DataModel[] = [];
    if(props.dataModels){
        if(!Array.isArray(props.dataModels)){
            if(!props.dataModels.destroyed){
                dataModels.push(props.dataModels);
            }
        } else {
            for(let dataModel of props.dataModels){
                if(dataModel && !dataModels.includes(dataModel) && !dataModel.destroyed){
                    dataModels.push(dataModel);
                }
            }
        }
    }

    let haveAllRequestedData = true;
    if(checkForUserLocation){
        haveAllRequestedData = getManager().location.isUserLocationDetermined(promptForUserLocation);
    }

    for(let dataModel of dataModels)
    {
        if(!dataModel.isPopulated() || dataModel.populating){
            haveAllRequestedData = false;
        }
    }
    const [isInitialized, setIsInitialized] = useState<boolean>(() => {
        return haveAllRequestedData && !getManager().navigation.routeIsProcessing
    });
    const [hasCurrentData, setHasCurrentData] = useState<boolean>(() => {
        return haveAllRequestedData
    });
    const [, setSimpleState] = useState<any[]>([]);

    if(!isPathActive() && !isInitialized){
        haveAllRequestedData = false;
    }

    if(checkForUserLocation){
        getManager().location.requireUserLocation(promptForUserLocation, true);
    }

    useEffect(() =>
    {

        let destroyed = false;

        const isActive = () => {
            return !destroyed && isPathActive();
        }

        const onRefreshUI = () => {

            if(!isActive())
            {
                return
            }
            setSimpleState([]);
        }

        const onUserLogInOut = () => {

            if(getManager().ui.isImmediateRedirect)
            {
                return
            }

            const doRedirect = getManager().user.loggedIn() ? props.redirectOnLogin : props.redirectOnLogout;

            if(doRedirect){
                dispatchRedirectHome(true);
            }
        }

        eventBus.on("site.refresh-ui", onRefreshUI);

        if(props.redirectOnLogin || props.redirectOnLogout){
            eventBus.on("site.on-user-log-in-out", onUserLogInOut);
        }


        return () =>
        {
            eventBus.remove("site.refresh-ui", onRefreshUI);

            eventBus.remove("site.on-user-log-in-out", onUserLogInOut);
            destroyed = true;
        };
    }, []);

    if(isPathActive()){

        for(let dataModel of dataModels)
        {
            if(!dataModel.isPopulated() && !dataModel.populating){
                dataModel.requirePopulated();
            }
        }

        if(haveAllRequestedData && !hasCurrentData){
            setIsInitialized(true)
            setHasCurrentData(true);
        }
    }

    let overrideView: React.JSX.Element|null = null;

    let didAssert = true;
    if(!isInitialized && !haveAllRequestedData){
        didAssert = false;
        overrideView = <LoadingPartial {...props.routeProps}/>;
    } else {
        if(props.assert || (props.assert === null)){
            const fromAssert = Array.isArray(props.assert) ? props.assert : [props.assert];

            for(let modelChoiceNull of fromAssert){
                if(!modelChoiceNull){
                    didAssert = false;
                    if(getManager().api.hasOpenFetchRequest())
                    {
                        overrideView = <LoadingPartial {...props.routeProps} />
                    } else {
                        overrideView = <ErrorConditionalPartial {...props.routeProps} />
                    }
                    break;
                }
            }
        }
    }
    if(!isInitialized && getManager().navigation.routeIsProcessing && didAssert){
        setIsInitialized(true)
    }

    return {
        isInitialized: isInitialized || haveAllRequestedData,
        hasCurrentData: hasCurrentData || haveAllRequestedData,
        overrideView: overrideView
    }
}
export default StateViewController;